export default __webpack_public_path__ + "static/media/Logo.d7b78831.jpg";